var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "activities-link-object",
      attrs: {
        visible: _vm.showModal,
        title: _vm.$t.__(
          "activities.dialog.ActivitiesLinkObjectDialog.link_object_title"
        ),
        primaryAction: _vm.primaryAction,
        secondaryActions: _vm.secondaryActions
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("SearchObjectToLinkComponent", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.objectSelected,
            expression: "!objectSelected"
          }
        ],
        attrs: {
          isVisible: !_vm.objectSelected,
          emptyStateData: _vm.emptyStateData
        },
        on: {
          objectSelected: function(value) {
            return (_vm.objectSelected = value)
          }
        }
      }),
      _vm._v(" "),
      _vm.objectSelected
        ? [
            _c(
              "div",
              {
                staticClass:
                  "typographies-paragraph-medium-semibold activities-link-object__selected-label"
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t.__("activities.labels.selected_object")) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _vm.objectSelected.blockType === "company"
              ? _c("BlockCompany", {
                  attrs: {
                    data: _vm.objectSelected.data,
                    showMobile: false,
                    showAddress: false,
                    variant: "linked"
                  },
                  on: {
                    unlink: function($event) {
                      _vm.objectSelected = null
                    }
                  }
                })
              : _vm.objectSelected.blockType === "contact"
              ? _c("BlockContact", {
                  attrs: {
                    data: _vm.objectSelected.data,
                    showPhone: false,
                    variant: "linked"
                  },
                  on: {
                    unlink: function($event) {
                      _vm.objectSelected = null
                    }
                  }
                })
              : _vm.objectSelected.blockType === "document"
              ? _c("BlockDocument", {
                  attrs: { data: _vm.objectSelected.data, variant: "linked" },
                  on: {
                    unlink: function($event) {
                      _vm.objectSelected = null
                    }
                  }
                })
              : _vm.objectSelected.blockType === "opportunity"
              ? _c("BlockOpportunity", {
                  attrs: { data: _vm.objectSelected.data, variant: "linked" },
                  on: {
                    unlink: function($event) {
                      _vm.objectSelected = null
                    }
                  }
                })
              : _vm.objectSelected.blockType === "individual"
              ? _c("BlockIndividual", {
                  attrs: { data: _vm.objectSelected.data, variant: "linked" },
                  on: {
                    unlink: function($event) {
                      _vm.objectSelected = null
                    }
                  }
                })
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }